
















































import { Component, Mixins } from "vue-property-decorator";
import { ForegroundDrawableObjectMixin } from "./mixins";
import { TabFocusEmulator } from "../../../system/utilities";
import { RangeOfMotionItem, GraphItem, TextBoxItem } from "../../../../domain/document/items";
import RangeOfMotionGraph from "./RangeOfMotionGraph.vue";
import RangeOfMotionRomInput from "./RangeOfMotionRomInput.vue";
import RangeOfMotionMmtInput from "./RangeOfMotionMmtInput.vue";
import { MuscularStrengthInputKinds, MuscularStrengthValueKinds } from "../../../../domain/document";

@Component({
  components: {
    RangeOfMotionGraph,
    RangeOfMotionRomInput,
    RangeOfMotionMmtInput,
  }
})
export default class RangeOfMotionObject extends Mixins(
  ForegroundDrawableObjectMixin,
) {
  editingSource: RangeOfMotionItem;

  get shouldShowInputByOfficialDocumentOrder(): boolean {
    // もとのオブジェクトの並び順の通りに表示するかどうかの議論もあったが、そこまでの機能は現状では不要とのことで2パターンの並び順にのみ対応している
    // index: V1で関節可動域を置いた直後の並び順（V3で当初実装した決め打ちの並び順）
    // official: 公的文書フォーマットでの調整済みの並び順（左から右）
    return this.$configuration.behavior.document.editor.objects.rangeOfMotion.orderOfObjects === "official";
  }
  
  get graphSource(): GraphItem {
    return this.readPropertyOrDefault(s => s.graph, null);
  }

  get lowRom(): TextBoxItem {
    return this.readPropertyOrDefault(s => s.rom.low, null);
  }

  set lowRom(value: TextBoxItem) {
    // nullにマイナスをかけると-0となってしまうのでガードを入れている
    const valueAsNumber = this.toNumber(value.value);
    this.writePropertyWhenValid(s => {
      s.rom.low = value;
      s.graph.rangeOfValue.low = (valueAsNumber != null) ? -valueAsNumber : null;
    });
  }

  get highRom(): TextBoxItem {
    return this.readPropertyOrDefault(s => s.rom.high, null);
  }

  set highRom(value: TextBoxItem) {
    this.writePropertyWhenValid(s => {
      s.rom.high = value;
      s.graph.rangeOfValue.high = this.toNumber(value.value);
    });
  }

  private toNumber(value: string): number {
    const valueAsNumber = !!value ? Number(value) : NaN;
    return !isNaN(valueAsNumber)
      ? valueAsNumber
      : null;
  }

  get lowMmt(): TextBoxItem {
    return this.readPropertyOrDefault(s => s.mmt.low, null);
  }

  set lowMmt(value: TextBoxItem) {
    this.writePropertyWhenValid(s => {
      s.mmt.low = value;
    });
    this.nextFocus();
  }

  get highMmt(): TextBoxItem {
    return this.readPropertyOrDefault(s => s.mmt.high, null);
  }

  set highMmt(value: TextBoxItem) {
    this.writePropertyWhenValid(s => {
      s.mmt.high = value;
    });
    this.nextFocus();
  }

  get mmtInputKind(): MuscularStrengthInputKinds {
    return this.editingSource.graph.muscularStrengthInputKind;
  }

  get mmtValueKind(): MuscularStrengthValueKinds {
    return this.editingSource.graph.muscularStrengthValueKind;
  }

  nextFocus(): void {
    TabFocusEmulator.emulate<HTMLInputElement>(this.$refs.root as Element, e => {
      e.focus();
      e.select();
    });
  }
}
